/**
 * leadership.js
 * copyright © 2022 Ania Management
 */
import React from "react";
import mathew from "../assets/images/Matthew1.png";
import charles from "../assets/images/Charles1.png";
import eric from "../assets/images/EricY1.png";
import daniel from "../assets/images/DanielGonzalez1.png";
import jonathan from "../assets/images/JonathenThen1.png";
import alex from "../assets/images/AlexK1.png";
import madeline from "../assets/images/MadelineRijo1.png";
import isreily from "../assets/images/IsreilyCruz1.png";
import ashley from "../assets/images/AshleyF1.png";
function Leadership() {
  //for putting data of faq's to state on page load
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className="content-wrapper leadership">
      <div className="ania-content">
        <div className="container-fluid px-0">
          <div className="main-content border-bottom">
            <div className="col-lg-12 px-lg-5 px-4">
              <h1 className="page-title page-title-lg mb-0">Leadership</h1>
            </div>
          </div>
        </div>
        <div className="container-width leadership-content-container">
          <div className="leadership-content">
            <div className="user">
              <div className="user-pic">
                <img src={mathew} alt="" />
              </div>
              <div className="user-details">
                <h6>Matthew Florio</h6>
                <strong>President</strong>
              </div>
              <p className="user-description">
                An esteemed real estate developer, sports enthusiast, and a
                philanthropist. He brings over fifteen years of real estate
                experience and relationships, acquiring and developing over
                4,500 units. Mr. Florio’s real estate holdings are over 700
                million.
              </p>
            </div>
            <div className="user">
              <div className="user-pic">
                <img src={charles} alt="" />
              </div>
              <div className="user-details">
                <h6>Charles Florio</h6>
                <strong>CEO</strong>
              </div>
              <p className="user-description">
                Charles Florio is involved in all aspects of running the
                business. His vision helped the company grow to 250 employees,
                4,500 units and expand across four states.
              </p>
            </div>
            <div className="user">
              <div className="user-pic">
                <img src={eric} alt="eric" />
              </div>
              <div className="user-details">
                <h6>Erik Yu</h6>
                <strong>Controller</strong>
              </div>
              <p className="user-description">
                Erik Yu provides oversight for the company’s accounting
                operation, cash management and financial planning.
              </p>
            </div>
            <div className="user">
              <div className="user-pic">
                <img src={daniel} alt="daniel" />
              </div>
              <div className="user-details">
                <h6>Daniel Gonzalez</h6>
                <strong>Vice President (Acquisitions)</strong>
              </div>
              <p className="user-description">
                Daniel Gonzalez is responsible for property acquisitions,
                ground-up development and ensuring the companies operational
                efficiencies.
              </p>
            </div>
            <div className="user">
              <div className="user-pic"></div>
              <div className="user-details">
                <h6>Jennifer Martinez</h6>
                <strong>Office Administrator</strong>
              </div>
            </div>
            <div className="user">
              <div className="user-pic">
                <img src={ashley} alt="ashley"/>
              </div>
              <div className="user-details">
                <h6>Ashley Florio</h6>
                <strong>Sr. Property Manager</strong>
              </div>
            </div>
            <div className="user">
              <div className="user-pic">
                <img src={jonathan} alt="" />
              </div>
              <div className="user-details">
                <h6>Jonathan Then</h6>
                <strong>Property Manager</strong>
              </div>
            </div>
            <div className="user">
              <div className="user-pic">
                <img src={alex} alt="alex" />
              </div>
              <div className="user-details">
                <h6>Alex Kasperowicz</h6>
                <strong>Property Manager</strong>
              </div>
            </div>
            <div className="user">
              <div className="user-pic">
                <img src={madeline} alt="madeline" />
              </div>
              <div className="user-details">
                <h6>Madeline Rijo</h6>
                <strong>Property Manager</strong>
                </div>
                <p className="user-description">
                  In addition to being a Property Manager, Madeline Rijo works
                  with local and state programs to ensure ANIA's relationship
                  with subsidy programs run smoothly.
                </p>
            </div>
            <div className="user">
              <div className="user-pic">
                <img src={isreily} alt="isreily" />
              </div>
              <div className="user-details">
                <h6>Isreily Cruz</h6>
                <strong>Property Manager</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Leadership;
